import { render, staticRenderFns } from "./VeJwQkXueshengList.vue?vue&type=template&id=753d5d7b&scoped=true"
import script from "./VeJwQkXueshengList.vue?vue&type=script&lang=js"
export * from "./VeJwQkXueshengList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "753d5d7b",
  null
  
)

export default component.exports